import {Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {connect} from 'react-redux'
import * as actEmailNotif from 'actions/setting/emailNotification'
import {FieldArray, Field, getFormValues, getFormSyncErrors} from 'redux-form'
import styles from './RecipientModal.css'

const renderFieldArray = ({fields, showSettingAlertRecipientsErrors, settingAlertRecipients}) => {
  return (
    <ul>
      <button className={`btn btn-primary btn-block ${styles['btn-add-email']}`}
        onClick={() => fields.push({email: ''})}
        type='button'>Add
      </button>

      {fields.map((member, index) => {
        return (<li key={index} style={{'position': 'relative'}}>
          {(settingAlertRecipients && index >= settingAlertRecipients.length) &&
          <Field
            name={`${member}.email`}
            component={renderField}
            disabled={index === 0}
            showSettingAlertRecipientsErrors={showSettingAlertRecipientsErrors}
          />
        }
          {(index > settingAlertRecipients.length) && <span className={styles['btn-remove-email']} onClick={() => fields.remove(index)} type='button'>
            <i className='fa fa-times-circle' />
          </span>}
        </li>)
      })}
    </ul>)
}

const renderField = ({input, meta: {touched, error}, disabled, showSettingAlertRecipientsErrors}) => {
  let errorClass = ''
  if (showSettingAlertRecipientsErrors && !disabled) {
    if (error) {
      errorClass = 'has-feedback has-error'
    } else {
      errorClass = 'has-feedback has-success'
    }
  }
  return (<div className={`form-group ${styles['form-group']} ${errorClass}`}>
    <input {...input} type='text' className={`form-control ${styles['input-email']}`} disabled={disabled} />
    {
      showSettingAlertRecipientsErrors && !disabled
        ? error
        ? <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>{error}</Tooltip>}>
          <span
            className={`form-control-feedback glyphicon glyphicon-remove ${styles['form-control-feedback']}`}
            style={{'pointer-events': 'auto', 'cursor': 'pointer'}}
              />
        </OverlayTrigger>
        : <span className={`form-control-feedback glyphicon glyphicon-ok ${styles['form-control-feedback']}`} />
        : ''
    }
  </div>)
}

class RecipientModal extends React.Component {
  render () {
    let {
      showRecipientModal,
      showSettingAlertRecipientsErrors,
      previousEmailNotificationForm
    } = this.props.data.setting.emailNotification

    let {settingAlertRecipients} = previousEmailNotificationForm

    return (<Modal show={showRecipientModal} dialogClassName={`${styles.dialog} modal-dialog`}>
      <Modal.Header>
        <Modal.Title>Add Email Recipients</Modal.Title>
      </Modal.Header>
      <Modal.Body bsClass={`modal-body ${styles.body}`}>
        <FieldArray
          name='settingAlertRecipients'
          component={renderFieldArray}
          showSettingAlertRecipientsErrors={showSettingAlertRecipientsErrors}
          settingAlertRecipients={settingAlertRecipients}
        />
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button type='button' className='btn btn-default pull-left' onClick={this._onCancel}>
            Cancel
          </button>
          <button type='button' className='btn btn-primary pull-right' onClick={this._onConfirm}>
            Confirm
          </button>
        </div>
      </Modal.Footer>
    </Modal>)
  }

  _onCancel = () => {
    const {previousEmailNotificationForm} = this.props.data.setting.emailNotification
    this.props.dispatch(actEmailNotif.onCancelManageRecipients(previousEmailNotificationForm))
  }

  _onConfirm = (e) => {
    const {emailNotificationForm, emailNotificationFormErrors, dispatch} = this.props
    let {settingAlertRecipients} = this.props.data.setting.emailNotification.previousEmailNotificationForm

    // we can only confirm if there is no error
    if (emailNotificationFormErrors && emailNotificationFormErrors.settingAlertRecipients && emailNotificationFormErrors.settingAlertRecipients.length) {
      // no op. force user to change email
      dispatch(actEmailNotif.showSettingAlertRecipientsErrors())
    } else {
      dispatch(actEmailNotif.onConfirmManageRecipients(emailNotificationForm, settingAlertRecipients))
    }
  }
}

function mapStateToProps (state) {
  return {
    emailNotificationFormErrors: getFormSyncErrors('emailNotification')(state),
    emailNotificationForm: getFormValues('emailNotification')(state),
    data: {
      setting: {
        emailNotification: state.setting.emailNotification
      }
    }
  }
};

export default connect(mapStateToProps)(RecipientModal)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/ReceipientModal/RecipientModal.js